/* eslint-disable react/display-name */
import React from 'react';
import { userPrivateRoutes } from './user-private';
import { userPublicRoutes } from './user-public';

export interface IRoutes {
  path: string;
  title?: string;
  element?: React.ReactNode;
  hideInSideBar?: boolean;
  children?: IRoutes[];
  isPublic?: boolean;
  icon?: any;
  isForTrainee?: boolean;
}

export const userRoutesLists: IRoutes[] = [...userPrivateRoutes, ...userPublicRoutes];
